import styled from '@emotion/styled';
import { Text } from '@innovationdepartment/proxima-ui';
import IncludedSection from './Layout/IncludedSection.View';
import { SubscriptionPlan } from '@innovationdepartment/proxima-sdk-axios';

type SelectedPlanViewProps = {
  onSubmit: () => void;
  loading: boolean;
  type: SubscriptionPlan;
};

const PlanInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const PercentageWrapper = styled.div`
  display: flex;
  gap: 4px;

  h3 {
    line-height: 36px;
  }

  span {
    margin-top: auto;
  }
`;

const PriceWrapper = styled.div`
  display: flex;
  gap: 4px;

  h3 {
    line-height: 36px;
  }

  span {
    margin-top: auto;
  }
`;

const options = {
  [SubscriptionPlan.MonthByMonth]: [
    <div style={{ display: 'flex', gap: '4px' }}>
      <Text>
        Category audiences{' '}
        <Text variant="tag2Semibold" color="neutral30">
          (Self-Serve)
        </Text>
      </Text>
    </div>,
    'Weekly seed refreshes',
    'Unlimited audience usage',
    'Month-to-month',
    'No contract',
  ],
  [SubscriptionPlan.Annual]: [
    <div style={{ display: 'flex', gap: '4px' }}>
      <Text>
        Category audiences{' '}
        <Text variant="tag2Semibold" color="neutral30">
          (Self-Serve)
        </Text>
      </Text>
    </div>,
    'Weekly seed refreshes',
    'Unlimited audience usage',
    <div style={{ display: 'flex', gap: '4px' }}>
      <Text>
        Billed annually{' '}
        <Text variant="tag2Semibold" color="green30">
          (Save $240)
        </Text>
      </Text>
    </div>,
  ],
};

const content = {
  [SubscriptionPlan.MonthByMonth]: (
    <>
      <PlanInformationWrapper>
        <PercentageWrapper>
          <Text variant="h3">$119</Text>
        </PercentageWrapper>
        <Text variant="body2" color="neutral50">
          Billed monthly
        </Text>
      </PlanInformationWrapper>
    </>
  ),
  [SubscriptionPlan.Annual]: (
    <>
      <PlanInformationWrapper>
        <PriceWrapper>
          <Text variant="h3">${99 * 12}</Text>
          <Text variant="body1Semibold">($99/mo)</Text>
        </PriceWrapper>
        <Text variant="body2" color="neutral50">
          Billed annually
        </Text>
      </PlanInformationWrapper>
    </>
  ),
};

const SelectedPlanView = ({ onSubmit, loading, type }: SelectedPlanViewProps) => (
  <>
    {content[type]}
    <IncludedSection
      buttonDisabled={loading}
      onSubmit={onSubmit}
      buttonText={loading ? 'Loading...' : 'Continue'}
      options={options[type]}
    />
  </>
);

export default SelectedPlanView;
